import React from 'react';
import './App.css';
import HomePage from './screens/HomePage';
import NotFound from './screens/NotFound';
import Login from './screens/Login';
import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import MisProductos from './screens/MisProductos';
import ExpirationsProduct from './screens/ExpirationsProduct';
import Categories from './screens/Categories';
import SocialMedia from './screens/SocialMedia';
import Carta from './screens/Carta';
import CartaOrderShop from './screens/CartaOrderShop';
import Orders from './screens/Orders';
import Menu from './components/Menu/Menu';
import ShopPage from "./screens/ShopPage";
import ReporteProductos from "./screens/ReporteProductos";
import ReporteCategorias from "./screens/ReporteCategorias";
import ReporteVentas from "./screens/ReporteVentas";
import Stock from "./screens/Stock";
import StockLocations from "./screens/StockLocations";
import StockMovements from "./screens/StockMovements";
import {ConfigProvider} from "./context/ConfigContext";
import StatusOrderView from "./screens/StatusOrderView";
import Configuraciones from "./screens/Configuraciones";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ClientList from "./screens/ClientList";
import InvoiceGenerator from "./components/invoice/invoiceGenerator";
import Brands from "./screens/Brands";
import PriceLists from './screens/PriceLists';
import Movement from "./screens/Movement";
import ReporteMovements from "./screens/ReporteMovements";
import Users from "./screens/Users";
import FlavorManagement from "./screens/FlavorManagement";
import Gustos1 from "./screens/Gustos1";
import Gustos1V2 from "./screens/Gustos1-V2";
import Gustos2 from "./screens/Gustos2";
import Gustos2V2 from "./screens/Gustos2-V2";
import IceCreamProductsTV from "./screens/IceCreamProductsTV";
import IceCreamProductsTVV2 from "./screens/IceCreamProductsTV-V2";
import Video from "./screens/Video";
import VideoV2 from "./screens/VideoV2";
import ImageOnly from "./screens/ImageOnly";
import GestionVideo from "./screens/GestionVideo";

function App() {
  return (
    <Router>
      <ToastContainer />
      <RoutesWithMenu />
    </Router>
  );
}

function isMainDomain(hostname) {
  // Localhost principal
  if (hostname === 'localhost' || hostname === 'localhost:3000') return true;

  // Dominio principal de producción
  if (hostname === 'qreate.ucoode.com.ar') return true;

  // Dominio admin específico de MiPiace
  if (hostname === 'mipiace-qreate.ucoode.com.ar') return true;

  return false;
}

function isSubdomain(hostname) {
  // Localhost subdominio con cualquier prefijo (ej: mipiace.localhost:3000)
  if (hostname.endsWith('.localhost') || hostname.match(/^[^.]+\.localhost:3000$/)) return true;

  // Subdominios de producción
  if (hostname.match(/^[^.]+-qreate\.ucoode\.com\.ar$/)) return true;

  // Dominio carta específico de MiPiace
  if (hostname === 'mipiace.ucoode.com.ar') return true;

  return false;
}

function RoutesWithMenu() {
  const location = useLocation();
  // Incluimos el puerto si existe (para localhost)
  const hostname = window.location.hostname + (window.location.port ? ':' + window.location.port : '');

  if (isMainDomain(hostname)) {
    // Rutas de display puro: no necesitan ConfigProvider ni Menu
    const displayRoutes = ['/video', '/video-v2'];
    if (displayRoutes.includes(location.pathname.toLowerCase())) {
      return (
        <Routes>
          <Route path="/video" element={<Video />} />
          <Route path="/video-v2" element={<VideoV2 />} />
        </Routes>
      );
    }

    const noMenuRoutes = ["/", "/carta", "/estadodelpedido", "/notfound", "/gustos-1", "/gustos-2", "/tv-productos", "/gustos-1-v2", "/gustos-2-v2", "/tv-productos-v2", "/imagen", "/imagen-v2"];
    const showMenu = !noMenuRoutes.includes(location.pathname.toLowerCase());

    return (
      <ConfigProvider>
        {showMenu && <Menu />}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/estadoDelPedido" element={<StatusOrderView />} />
          <Route path="/pedidoMostrador" element={<CartaOrderShop />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/users" element={<Users />} />
          <Route path="/misProductos" element={<MisProductos />} />
          <Route path="/flavors" element={<FlavorManagement />} />
          <Route path="/expirationsProduct" element={<ExpirationsProduct />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/marcas" element={<Brands />} />
          <Route path="/personalizacion" element={<SocialMedia />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/reporteProductos" element={<ReporteProductos />} />
          <Route path="/reporteCategorias" element={<ReporteCategorias />} />
          <Route path="/reporteMovimientos" element={<ReporteMovements />} />
          <Route path="/reporteVentas" element={<ReporteVentas />} />
          <Route path="/config" element={<Configuraciones />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/stockLocations" element={<StockLocations />} />
          <Route path="/stockMovements" element={<StockMovements />} />
          <Route path="/client" element={<ClientList />} />
          <Route path="/invoice" element={<InvoiceGenerator />} />
          <Route path="/price-lists" element={<PriceLists />} />
          <Route path="/movements" element={<Movement />} />
          <Route path="/gustos-1" element={<Gustos1 />} />
          <Route path="/gustos-2" element={<Gustos2 />} />
          <Route path="/tv-productos" element={<IceCreamProductsTV />} />
          <Route path="/gustos-1-V2" element={<Gustos1V2 />} />
          <Route path="/gustos-2-V2" element={<Gustos2V2 />} />
          <Route path="/tv-productos-V2" element={<IceCreamProductsTVV2 />} />
          <Route path="/imagen" element={<ImageOnly rotation="left" />} />
          <Route path="/imagen-v2" element={<ImageOnly rotation="right" />} />
          <Route path="/gestion-video" element={<GestionVideo />} />
        </Routes>
      </ConfigProvider>
    );
  }

  if (isSubdomain(hostname)) {
    return (
        <ConfigProvider>
          <Routes>
            <Route path="/" element={<Carta />} />
            <Route path="/estadoDelPedido" element={<StatusOrderView />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ConfigProvider>
    );
  }

  // Si no es ninguno de los casos, NotFound
  return <NotFound />;
}

export default App;
